export enum TransfersFilesStatus {
    Creating = 1,
    Sending = 2,
    CreationError = 3,
    SentError = 4,
    Done = 5,
    Sharing = 6,
    SharingError = 7,
    WaitingCreationWindow = 8
}